<template>
  <el-select v-model="routeOpt" @change="handleSelectRoute" size="mini" clearable placeholder="请选择其他页面">
    <el-option-group v-for="group in filteredRouteOptGroups" :key="group.label" :label="group.label">
      <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
export default {
  props: {
    currentRoute: {
      type: String,
      required: true
    },
    siteId: {
      type: String,
      required: true
    },
    projectId: {
      type: String,
      required: true
    },
    siteType: {
      type: String,
      required: true
    }
  },
  computed: {
    filteredRouteOptGroups() {
      const allRoutes = this.$store.getters.allRoutes;

      return allRoutes.map(group => ({
        ...group,
        options: group.options.filter(option => option.value !== this.currentRoute)
      })).filter(group => group.options.length > 0);
    }
  },
  data() {
    return {
      routeOpt: null,
    };
  },
  methods: {
    handleSelectRoute(value) {
      if (['record_zg_index', 'record_cma_index', 'report_zg_index', 'report_cma_index', 'site_doc'].includes(value)) {
        this.$router.push({
          name: value,
          params: {
            project_id: this.projectId,
            site_id: this.siteId,
            site_type: this.siteType
          }
        })
      } else if (value === 'site_down') {
        console.log('site_down');
      }
    },
  },
}
</script>

<style scoped></style>